import cx from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { AppActions, BaseActions, FileActions, ProjectActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import {
  testVeiwthumbnail_1,
  testVeiwthumbnail_2,
  testVeiwthumbnail_3,
} from 'containers/base/PmsConnect';
import { useHistory, useLocation } from 'react-router-dom';
import PlainModal from 'components/common/modal/PlainModal';
import AppModal from 'components/common/modal/AppModal';
import Color from 'color';
import { T } from 'components/common/text';
import MuiButton from 'components/common/button/MuiButton';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import { color } from 'styles/utils';
import { useTranslation } from 'react-i18next';
import {
  handleClearScanEdit,
  handleClearScanprocess,
  scan_finish_build,
  scan_progress_build,
  scan_start_build,
  scan_store_build,
  testScanFinish,
  testScanProcess,
  testScanStart,
  testScanStartProcessing,
  testScanStore,
  testScanStore2,
  testScanWriteIndication,
} from 'containers/base/ScanProcessChecker';
import { ENV_MODE_PROD } from 'lib/setting';
import { useCreateProjectInfoStore } from 'store/local/projectCreateinfo';
import { useProject } from 'lib/hooks/project/useProject';

export default function ScanProcessContainer() {
  const { scanProcess, scanEdit, projectFilesSuccess } = useShallowAppSelector(state => ({
    scanProcess: state.base.scanProcess,
    scanEdit: state.base.scanEdit,
    projectFilesSuccess: state.file.projectFiles.success,
  }));

  const { isInfoOpen, setIsInfoOpen, isIndicationOpen, setIsIndicationOpen } =
    useCreateProjectInfoStore();
  const { handleClickProjectTab } = useProject();
  const [scanProjectCode, setScanProjectCode] = useState<string>('');

  const [building, setBuilding] = useState<boolean>(false);
  const [processing, setProcessing] = useState<number>(0);
  const [startBlink, setStartBlink] = useState<boolean>(false);
  const history = useHistory();
  const location = useLocation();

  const { t } = useTranslation();
  const [editProjectAlertOpen, setEditProjectAlertOpen] = useState(false);
  const [editProjectCode, setEditProjectCode] = useState<string>('');

  const [finishBuildAlertOpen, setFinishBuildAlertOpen] = useState(false);
  const [finishBuildProjectCode, setFinishBuildProjectCode] = useState<string>('');

  const [goToFileSyncTab, setGoToFileSyncTab] = useState<boolean>(false);
  const [scanFileUploadFinish, isScanFileUploadFinish] = useState<boolean>(false);

  const handleOpenEditProjectAlert = () => setEditProjectAlertOpen(true);
  const handleCloseEditProjectAlert = () => {
    handleClearScanEdit();
    handleClearScanprocess();
    setEditProjectAlertOpen(false);
  };

  const handleClickEditProject = (pCode: string) => {
    handleClearScanEdit();
    // const editPath = `/project/creating/${scanEdit.projectCode}?pathTo=edit`;
    const editPath = `/project/creating/${pCode}?pathTo=scanEdit`;
    history.push(editPath);
    handleCloseEditProjectAlert();
  };

  const handleOpenFinishBuildAlert = (pCode: string) => {
    setFinishBuildAlertOpen(true);
    setFinishBuildProjectCode(pCode);
  };
  const handleCloseFinishBuildAlert = () => {
    // handleClearScanEdit();
    handleClearScanprocess();
    setFinishBuildAlertOpen(false);
    setFinishBuildProjectCode('');
  };

  const handleClickGoProject = (pCode: string) => {
    const editPath = `/project/creating/${pCode}?pathTo=scanFinish&tab=1`;
    history.push(editPath);
    handleCloseFinishBuildAlert();
    handleClearScanEdit();
    setIsInfoOpen(false);
    setIsIndicationOpen(false);
  };

  useEffect(() => {
    let blink: any;
    if (!!building) {
      blink = setTimeout(() => {
        setStartBlink(true);
      }, 500);
    }
    return () => {
      clearTimeout(blink);
    };
  }, [building]);

  useEffect(() => {
    if (!scanEdit || !scanEdit.projectCode) return;
    const editPath = `/project/detail/${scanEdit.projectCode}`;
    if (location.pathname === editPath) {
      handleClearScanEdit();
      return;
    }
    handleOpenEditProjectAlert();
    setEditProjectCode(scanEdit.projectCode);
  }, [scanEdit, location]);

  useEffect(() => {
    if (!scanProcess || !scanProcess.command) return;
    switch (scanProcess.command) {
      case scan_start_build:
        // 빌드 시작
        console.log('SCAN] scanProcess ' + scanProcess.command + '__________ ', scanProcess.data);

        setBuilding(true);
        setProcessing(0);
        if (!!scanProcess.data?.projectCode) {
          setScanProjectCode(scanProcess.data.projectCode);
        }
        break;
      case scan_progress_build:
        // 빌드 중
        console.log('SCAN] scanProcess ' + scanProcess.command + '__________ ', scanProcess.data);
        setBuilding(true);
        setProcessing(scanProcess.data.progress);
        if (!!scanProcess.data?.projectCode) {
          setScanProjectCode(scanProcess.data.projectCode);
        }
        break;
      case scan_finish_build:
        // 빌드 종료
        console.log('SCAN] scanProcess ' + scanProcess.command + '__________ ', scanProcess.data);
        if (!!scanProcess.data?.projectCode) {
          setScanProjectCode(scanProcess.data.projectCode);
        }
        setTimeout(() => {
          setBuilding(false);
          setProcessing(0);
          setScanProjectCode('');
        }, 3000);
        break;
      case scan_store_build:
        // 파일 업로드
        console.log('SCAN] scanProcess ' + scanProcess.command + '__________ ', scanProcess.data);
        const messgae = scanProcess.data?.msg || '';
        console.log('SCAN] messgae ____________', messgae);
        if (!messgae || messgae === 'SUCCESS') {
          console.log('SCAN] SUCCESS _______ data ___ ', scanProcess.data.projectCode);

          const projectPath = `/project/detail/${scanProcess.data.projectCode}`;
          if (location.pathname === projectPath) {
            // 프로젝트 내
            if (!!isInfoOpen || !!isIndicationOpen) {
              // 수정중 인 경우
              handleOpenFinishBuildAlert(scanProcess.data.projectCode);
            } else {
              setGoToFileSyncTab(true);
              FileActions.fetch_project_files_request(scanProcess.data.projectCode);
              // handleClickProjectTab(1, true);
              // handleCloseFinishBuildAlert();
              // handleClickGoProject(scanProcess.data.projectCode);
            }
          } else {
            handleOpenFinishBuildAlert(scanProcess.data.projectCode);
          }
          return;
        } else {
          // ‘SUCCESS’ : 성공
          // ‘OUT_OF_STORAGE’ : 클라우드 공간 부족
          // ‘CANNOT_UPLOAD_PROJECT_FILE’ : 업로드 중 문제 또는 에러로 업로드 할 수 없음 }
          AppActions.add_popup({
            isOpen: true,
            title: t('GLOBAL_NOTIFICATION'),
            content: t(`NOTIFICATION_${messgae}`),
            isTitleDefault: true,
            isContentDefault: true,
            onClick: () => {
              BaseActions.scan_process({ command: null, data: null });
            },
          });
        }
        break;

      default:
        break;
    }
  }, [scanProcess, location]);

  useEffect(() => {
    if (!projectFilesSuccess || !goToFileSyncTab) return;
    handleClickProjectTab(1, true);
    handleCloseFinishBuildAlert();
    setGoToFileSyncTab(false);
  }, [projectFilesSuccess, goToFileSyncTab]);

  const handleClickProgress = (pcode: string) => {
    if (!pcode) return;
    const projectPath = `/project/detail/${pcode}`;
    if (location.pathname !== projectPath) {
      const path = `/project/creating/${pcode}?pathTo=detail`;
      history.push(path);
    }
  };

  return (
    <StyledScanProcess data-component-name="ScanProcess">
      {useMemo(
        () => (
          <PlainModal
            isOpen={finishBuildAlertOpen}
            onClose={handleCloseFinishBuildAlert}
            width={570}
          >
            <AppModal
              title={t('GLOBAL_NOTIFICATION')}
              headerCenterText={''}
              headerCenterTextStyle={{ width: 325 }}
              content={
                <ScanBuildFinishAlert
                  projectCode={finishBuildProjectCode}
                  onClose={handleCloseFinishBuildAlert}
                  onClick={handleClickGoProject}
                />
              }
              contentCardStyle={{
                padding: '0',
                borderRadius: '8px',
              }}
              isCloseIcon={true}
              onCancel={handleCloseFinishBuildAlert}
              hideButton={true}
            />
          </PlainModal>
        ),
        [finishBuildAlertOpen, finishBuildProjectCode],
      )}
      {useMemo(
        () => (
          <PlainModal
            isOpen={editProjectAlertOpen}
            onClose={handleCloseEditProjectAlert}
            width={570}
          >
            <AppModal
              title={t('GLOBAL_NOTIFICATION')}
              headerCenterText={''}
              headerCenterTextStyle={{ width: 325 }}
              content={
                <ScanIndicationEditAlert
                  editProjectCode={editProjectCode}
                  onClose={handleCloseEditProjectAlert}
                  onClick={handleClickEditProject}
                />
              }
              contentCardStyle={{
                padding: '0',
                borderRadius: '8px',
              }}
              isCloseIcon={true}
              onCancel={handleCloseEditProjectAlert}
              hideButton={true}
            />
          </PlainModal>
        ),
        [editProjectAlertOpen, editProjectCode],
      )}
      <div
        className={cx('scanProcess__wrapper', {
          start: !!building,
          end: !building,
        })}
        onClick={() => {
          handleClickProgress(scanProjectCode);
        }}
      >
        <div
          className={cx('scanProcess__container', {
            blink: !!startBlink,
          })}
        >
          <div className="scanProcess__state_box">
            <span className="scanProcess__state">
              {processing === 100 ? 'Processing Complete' : 'Processing...'}
            </span>
          </div>
          <div className="scanProcess__progress_box">
            <div className="scanProcess__progress" style={{ width: `${processing}%` }}></div>
          </div>
          <div></div>
        </div>
      </div>
      {!ENV_MODE_PROD && (
        <div className="test_button">
          <button onClick={() => testVeiwthumbnail_1(history)}>viewThumbnail 1</button>
          <button onClick={() => testVeiwthumbnail_2(history)}>viewThumbnail 2</button>
          <button onClick={() => testVeiwthumbnail_3(history)}>viewThumbnail 3</button>
          <button onClick={() => testScanWriteIndication()}>scan edit project</button>
          <button onClick={() => testScanStart()}>testScanStart</button>
          <button onClick={() => testScanStartProcessing()}>testScanStartProcessing</button>
          <button onClick={() => testScanProcess()}>testScanProcess</button>
          <button onClick={() => testScanFinish()}>testScanFinish</button>
          <button onClick={() => testScanStore()}>testScanStore</button>
          <button onClick={() => testScanStore2()}>testScanStore2</button>
        </div>
      )}
    </StyledScanProcess>
  );
}

const StyledScanProcess = styled.div<{}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  width: 100%;
  .scanProcess__wrapper {
    width: 160px;
    height: 42px;
    border-radius: 3px;
    border: 1px solid #e1e1e7;
    background-color: #fff;
    overflow: hidden;
    &:hover {
      cursor: pointer;
    }

    &.start {
      visibility: visible;
      opacity: 1;
    }
    &.end {
      visibility: hidden;
      opacity: 0;
      transition: all 1s;
    }
    .scanProcess__container {
      width: inherit;
      height: inherit;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &.blink {
        animation: blink 1s ease-in-out infinite alternate;
      }
      .scanProcess__state_box {
        height: 37px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        .scanProcess__state {
          font-size: 13px;
          font-weight: 400px;
          line-height: 18px;
        }
      }
      .scanProcess__progress_box {
        height: 3px;
        width: 100%;
        .scanProcess__progress {
          height: 3px;
          background-color: #00bee2;
        }
      }
    }
  }

  .test_button {
    margin-top: 30px;
    height: 100px;
    overflow-y: scroll;
    button {
      margin-bottom: 10px;
    }
  }

  @keyframes blink {
    0% {
      box-shadow: 0px 0px 15px 0px rgba(0, 190, 226, 0.1) inset;
    }
    100% {
      box-shadow: 0px 0px 15px 0px rgba(0, 190, 226, 0.5) inset;
    }
  }
  @keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      visibility: hidden;
    }
  }
`;

const ScanIndicationEditAlert = ({
  editProjectCode,
  onClose,
  onClick,
}: {
  editProjectCode: string;
  onClose: () => void;
  onClick: (pCode: string) => void;
}) => {
  return (
    <StyledScanIndicationEditAlert data-component-name="ScanIndicationEditAlert">
      <div className="scanIndicationEditAlert__container">
        <T>NOTIFICATION_PROJECT_ORDER</T>
      </div>
      <StyledPlainButtonOuter
        className="partnerModalRequest__button_container"
        backgroundColor={color.navy_blue}
        left="50%"
        width={410}
        height={76}
      >
        <div className="partnerModalRequest__button_box">
          <MuiButton
            config={{
              width: '95px',
              color: color.gray_week,
            }}
            disableElevation
            variant="contained"
            className="xl border-radius-round inset-shadow-default partnerModalRequest__cancel_button"
            onClick={() => {
              onClose();
            }}
          >
            <T>GLOBAL_CANCEL</T>
          </MuiButton>
          <MuiButton
            config={{
              width: '295px',
            }}
            disableElevation
            variant="contained"
            className="xl border-radius-round inset-shadow-default partnerModalRequest__save_button"
            onClick={() => {
              onClick(editProjectCode);
            }}
          >
            <span className="btn-shadow-inset"></span>
            <T>GLOBAL_OK</T>
          </MuiButton>
        </div>
      </StyledPlainButtonOuter>
    </StyledScanIndicationEditAlert>
  );
};

const StyledScanIndicationEditAlert = styled.div<{}>`
  position: relative;
  .scanIndicationEditAlert__container {
    width: 100%;
    margin-bottom: 30px;
    position: relative;
    background-color: #ffffff;
    border-radius: 15px;
    padding: 35px 35px 70px 35px;
    line-height: 1.3;
  }

  .partnerModalRequest__button_container {
    .partnerModalRequest__button_box {
      position: relative;
      display: flex;
      .partnerModalRequest__cancel_button {
        position: relative;
        z-index: 2;
      }
      .partnerModalRequest__save_button {
        margin-left: -10px;
        background: rgb(0, 166, 226);
        background: linear-gradient(90deg, rgba(0, 166, 226, 1) 0%, rgba(8, 123, 238, 1) 100%);
        border: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        overflow: hidden;
        &:hover {
          background: ${`linear-gradient(
            90deg,
            ${Color('rgba(0, 166, 226, 1)').darken(0.12)} 0%,
            ${Color('rgba(8, 123, 238, 1)').darken(0.12)} 100%
          )`};
        }
        .btn-shadow-inset {
          position: absolute;
          top: -5px;
          left: -46px;
          width: 66px;
          height: 66px;
          border-radius: 33px;
          background-color: ${color.navy_blue};
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
        }
      }
    }
  }
`;

const ScanBuildFinishAlert = ({
  projectCode,
  onClose,
  onClick,
}: {
  projectCode: string;
  onClose: () => void;
  onClick: (pCode: string) => void;
}) => {
  return (
    <StyledScanBuildFinishAlert data-component-name="ScanIndicationEditAlert">
      <div className="scanIndicationEditAlert__container">
        <div>
          <T>NOTIFICATION_BUILD_FINISH</T>
        </div>
        <div>
          <T>NOTIFICATION_BUILD_FINISH_NOTI</T>
        </div>
      </div>
      <StyledPlainButtonOuter
        className="partnerModalRequest__button_container"
        backgroundColor={color.navy_blue}
        left="50%"
        width={410}
        height={76}
      >
        <div className="partnerModalRequest__button_box">
          <MuiButton
            config={{
              width: '95px',
              color: color.gray_week,
            }}
            disableElevation
            variant="contained"
            className="xl border-radius-round inset-shadow-default partnerModalRequest__cancel_button"
            onClick={() => {
              onClose();
            }}
          >
            <T>GLOBAL_CANCEL</T>
          </MuiButton>
          <MuiButton
            config={{
              width: '295px',
            }}
            disableElevation
            variant="contained"
            className="xl border-radius-round inset-shadow-default partnerModalRequest__save_button"
            onClick={() => {
              onClick(projectCode);
            }}
          >
            <span className="btn-shadow-inset"></span>
            <T>GLOBAL_OK</T>
          </MuiButton>
        </div>
      </StyledPlainButtonOuter>
    </StyledScanBuildFinishAlert>
  );
};

const StyledScanBuildFinishAlert = styled.div<{}>`
  position: relative;
  .scanIndicationEditAlert__container {
    width: 100%;
    margin-bottom: 30px;
    position: relative;
    background-color: #ffffff;
    border-radius: 15px;
    padding: 35px 35px 70px 35px;
    line-height: 1.3;
  }

  .partnerModalRequest__button_container {
    .partnerModalRequest__button_box {
      position: relative;
      display: flex;
      .partnerModalRequest__cancel_button {
        position: relative;
        z-index: 2;
      }
      .partnerModalRequest__save_button {
        margin-left: -10px;
        background: rgb(0, 166, 226);
        background: linear-gradient(90deg, rgba(0, 166, 226, 1) 0%, rgba(8, 123, 238, 1) 100%);
        border: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        overflow: hidden;
        &:hover {
          background: ${`linear-gradient(
            90deg,
            ${Color('rgba(0, 166, 226, 1)').darken(0.12)} 0%,
            ${Color('rgba(8, 123, 238, 1)').darken(0.12)} 100%
          )`};
        }
        .btn-shadow-inset {
          position: absolute;
          top: -5px;
          left: -46px;
          width: 66px;
          height: 66px;
          border-radius: 33px;
          background-color: ${color.navy_blue};
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
        }
      }
    }
  }
`;
